// src/pages/navbar.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './navbar.css';          // CSS in dezelfde map (src/pages/navbar.css)

// Logo moet in src/ staan
import logo from '../logo.png'; // omdat navbar.js in src/pages/ staat, gaat '../logo.png' naar src/logo.png

import { useAuth } from '../AuthContext'; // AuthContext.js in src/

function Navbar() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/inloggen'); // na uitloggen naar /inloggen
    } catch (err) {
      console.error('Log out mislukt:', err);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
      </div>

      {/* Hamburger menu button for mobile */}
      <button 
        className="mobile-menu-button" 
        onClick={toggleMenu}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
      >
        <span>Menu</span>
        <div className={`hamburger-icon ${menuOpen ? 'open' : ''}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
        <li>
          <Link to="/" onClick={closeMenu}>Home</Link>
        </li>
        <li>
          <Link to="/hsbakbord" onClick={closeMenu}>HSBakBord</Link>
        </li>
        <li>
          <Link to="/hsbakrad" onClick={closeMenu}>HSBakRad</Link>
        </li>
        {/* Als er géén ingelogde gebruiker is, toon alleen "Login" */}
        {!currentUser && (
          <li>
            <Link to="/login" onClick={closeMenu}>Login</Link>
          </li>
        )}

        {/* Als er wél een ingelogde gebruiker is, toon alleen Account link */}
        {currentUser && (
          <li>
            <Link to="/account" onClick={closeMenu}>Account</Link>
          </li>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;
